// Scaled slide thumbnail. Slides are authored against a full-viewport
// contract with clamp() minimums in px — rendered raw at thumbnail size
// the text can't shrink and the layout shatters. Render at a full
// logical viewport (1280×720) and CSS-scale the iframe down instead,
// exactly like the dashboard preview grid does.
import { useLayoutEffect, useRef, useState } from 'react';

const BASE_W = 1280;
const BASE_H = 720;

export default function SlideThumb({ src, title }: { src: string; title: string }) {
  const ref = useRef<HTMLDivElement | null>(null);
  const [scale, setScale] = useState(0);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const update = () => setScale(el.clientWidth / BASE_W);
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <div ref={ref} style={{ position: 'relative', width: '100%', aspectRatio: '16/9', overflow: 'hidden', background: '#fff' }}>
      {scale > 0 && (
        <iframe
          src={src}
          title={title}
          loading="lazy"
          sandbox=""
          style={{
            width: BASE_W,
            height: BASE_H,
            border: 'none',
            pointerEvents: 'none',
            transform: `scale(${scale})`,
            transformOrigin: 'top left',
            background: '#fff',
          }}
        />
      )}
    </div>
  );
}
